import styled from 'styled-components';

const Container = styled.div`
  background:#fff;
  .zhibo-floor{
    width: 7.15rem;
    height: 3.7rem;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom:.3rem;
  }
  .left-part{
    position: relative;
    width: 3.32rem;
    height: 3.32rem;
    margin-right:.2rem;
  }
  .zhibo-img{
    width: 3.32rem;
    height: 3.32rem;
    border-radius: .08rem;
  }
  .zhibo-flag{
    position: absolute;
    top: .12rem;
    left: .12rem;
    border-radius: .2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .zhibo-flag.yugao{
    background-image:unset;
  }
  .zhibo-flag-icon{
    width: .2rem;
    height: .2rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .zhibo-flag.huifang .zhibo-flag-icon{
    background-image: url(https://img13.360buyimg.com/imagetools/jfs/t1/129112/31/377/552/5eb500fbEc1560345/75f2d02b7073352d.png);
  }
  .zhibo-flag.zhibozhong .zhibo-flag-icon{
    background-image: url(https://img11.360buyimg.com/imagetools/jfs/t1/122613/36/408/560/5eb500fbE45975d28/e7189538036f449e.png);
  }
  .zhibo-flag.yugao .zhibo-flag-icon{
    background-image: url(https://img10.360buyimg.com/imagetools/jfs/t1/127188/6/377/1768/5eb500fbEdd855676/9b508a7d40617e8d.png);
  }
  .zhibo-flag-txt{
    font-size:.2rem;
    color:#fff;
    padding-left:.1rem;
  }
  .right-part{
    position: relative;
    flex:1;
    height: 3.32rem;
  }
  .zhibo-title{
    font-family: PingFangSC-Medium;
    font-size: .3rem;
    line-height: .4rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .pro-imgs{
    display: flex;
    flex-direction: row;
    margin-top:.4rem;
  }
  .pro-imgs img{
    max-height: 1rem;
    max-width: 1rem;
    margin-right: .1rem;
    border-radius: .08rem;
  }
  .zhibo-btn{
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    right: .2rem;
    background-image: linear-gradient(90deg, rgb(239, 70, 70) 0%, rgb(225, 48, 48) 100%);
    border-radius: 4rem;
    padding: .14rem .22rem;
    line-height: .24rem;
  }
  .zhibo-btn-txt{
    font-size: .24rem;
    color: #fff;
    font-family: PingFangSC-Regular;
  }
  .zhibo-btn-icon{
    width: .12rem;
    height: .18rem;
    margin-left:.07rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url(https://m.360buyimg.com/img/jfs/t1/65985/4/18662/731/62838b96Ef8476c42/6ce00c2869b9d992.png);
  }

  .zhibo-txt{
    padding:0.07rem 0.15rem;
    display: flex;
    align-items: center;
    border-bottom-left-radius: 0.2rem;
    border-top-left-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    background-image: linear-gradient(90deg, #ff785e 0%, #fe404d 100%);
  }
  .zhibo-flag.yugao .zhibo-txt{
    background-image: linear-gradient(90deg,#49e1af 0%,#2fb09d 100%),linear-gradient(90deg,#ff785e 0%,#fe404d 100%);
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .yugao-time{
    padding:0.07rem 0.15rem .07rem .07rem;
    font-size: .20rem;
    color:#fff;
    background-color: rgba(0,0,0,0.3);
    border-bottom-right-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
  }
`

export {
  Container
}